<template>
    <div class="mMaridaje-container" :class="{onlySafari: isSafari}" v-observe-visibility="startAnimate">
        <div class="neonTittles">
            <img class="neonMaridaje" :src="neonMaridaje" :class="{animate: animate}" alt="Tecate 0.0 es ideal para maridar con comida callejera ">
            <img class="tktRedNeonLight" :src="tktRedNeonLight" :class="{animate: animate}" alt="Tecate 0.0 es ideal para maridar con comida de puestos y toda la gastronomia mexicana que puedas encontrar en las calles de México">
        </div>
        <div class="foodsExamples">
            <div class="imgFoods">
                <p class="tittleImg">TACOS</p>
                    <img class="imgMaridaje" :class="{animate: animate, onlySafari: isSafari}" :src="tacos" alt="Necesitas 0.0 pretextos para comer Tacos con la NUEVA Tecate 0.0">
                <p class="tittleImg2">¡De todo tipo!</p>
            </div>
            <div class="imgFoods">
                <P class="tittleImg">TORTAS</P>
                    <img class="imgMaridaje" :class="{animate: animate, onlySafari: isSafari}" :src="cakes" alt="Necesitas 0.0 pretextos para comer Tortas con la NUEVA Tecate 0.0">
                <p class="tittleImg2">¡Lo que más<br> se te antoje!</p>
            </div>
            <div class="imgFoods">  
                <p class="tittleImg">ANTOJITOS</p>
                    <img  class="imgMaridaje" :class="{animate: animate, onlySafari: isSafari}" :src="whim" alt="Necesitas 0.0 pretextos para disfrutar de tus antojitos favoritos con la NUEVA Tecate 0.0">
                <p class="tittleImg2">¡De los que tú<br> ya conoces!</p>
            </div>
            <div class="imgFoods">
                <p class="tittleImg">BOTANA</p>
                    <img class="imgMaridaje" :class="{animate: animate, onlySafari: isSafari}" :src="snack" alt="Necesitas 0.0 pretextos para disfrutar de tus botanas favoritas con la NUEVA Tecate 0.0">
                <p class="tittleImg2">¡La de siempre!</p>
            </div>
        </div>
        <div class="bannerMaridaje" :class="{onlySafari: isSafari}"></div>
    </div>
</template>

<script>
import neonMaridaje from '@/assets/tkt-maridaje/MARIDAJE-NEON.png';
import tktRedNeonLight from '@/assets/tkt-maridaje/TECATE-NEON-ROJO.png';
import bannerMaridaje from '@/assets/tkt-maridaje/BANNER.png';
import tacos from '@/assets/tkt-maridaje/TACOS.png';
import cakes from '@/assets/tkt-maridaje/TORTAS.png';
import whim from '@/assets/tkt-maridaje/ANTOJITOS.png';
import snack from '@/assets/tkt-maridaje/BOTANA.png';
import bannerFoods from '@/assets/tkt-maridaje/BANNER-TECATE-COMIDA.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
    name: "Elaboration",
    data() {
        return {
            animate: false,
            isSafari: false,
            whim,
            bannerMaridaje,
            snack,
            neonMaridaje,
            tacos,
            tktRedNeonLight,
            cakes,
            bannerFoods
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if (isVisible) {
                this.animate = true
            }
        },
    },
    components: {},
    mounted() {
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName() == 'Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Maridaje.scss";
</style>